import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { QRCodeSVG } from 'qrcode.react';
import axios from 'axios';


const StockFinancials = () => {
  const [viewOption, setViewOption] = useState("Summary");
  const [searchQuery, setSearchQuery] = useState("");
  const [inventoryData, setInventoryData] = useState([]);
  const [selectedPharmacy, setSelectedPharmacy] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('On shelf');
  const [priceThreshold, setPriceThreshold] = useState(0);
  const [expiringWithin, setExpiringWithin] = useState("");
  const [onShelfMoreThan, setOnShelfMoreThan] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [popupData, setPopupData] = useState(null);
const [selectedLocation, setSelectedLocation] = useState('');
const [splitPackOnly, setSplitPackOnly] = useState(false);
const [logPopupData, setLogPopupData] = useState(null);
const [statusPopupData, setStatusPopupData] = useState(null);
    const [statusPopupTitle, setStatusPopupTitle] = useState("");
    const [popupSearchQuery, setPopupSearchQuery] = useState("");
const members = JSON.parse(localStorage.getItem("members") || "[]");
const memberNames = members.map(m => m.pharmacyName);
const inventoryNames = inventoryData.map(item => item.pharmacyName);
const shelfChecks = JSON.parse(localStorage.getItem("shelf_checks") || "[]");

const matched = members.find(m => m.pharmacyName === selectedPharmacy);
const pharmacyId = matched ? matched.pharmacyId : "";
let filteredShelves = shelfChecks;

if (selectedPharmacy) {
  filteredShelves = shelfChecks.filter(shelf => shelf.pharmacyId === pharmacyId);
}
const uniqueLocations = [...new Set(filteredShelves.map(shelf => shelf.description))].sort();




// Combine and deduplicate
const combinedPharmacyNames = [...new Set([...memberNames, ...inventoryNames])].sort();


useEffect(() => {
  fetchInventoryData();
}, []);

const fetchInventoryData = async () => {
  const groupId = localStorage.getItem("userId");
  if (!groupId) return;

  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(`https://api.pharmacegroup.co.uk/ggetInventory?groupId=${groupId}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    let data = await response.json();
    data = data.filter(item => !item.pharmacyName?.startsWith("Warehouse"));
    setInventoryData(data);
  } catch (error) {
    console.error("Error fetching inventory data:", error);
  }
}; // ← You were missing this closing brace

const handlePopupExport = () => {
  if (!sortedPopupData || sortedPopupData.length === 0) return;

  const worksheetData = [
    [`${statusPopupTitle} Drugs`],
    [`Generated on: ${new Date().toLocaleString()}`],
    [],
    ['Pharmacy', 'Drug', 'Packets', 'Qty', 'Price (£)', 'Location', 'Serial', 'Batch', 'Expiry', 'First Scanned'],
  ];

  sortedPopupData.forEach(item => {
    worksheetData.push([
      item.pharmacyName,
      item.drugName || item.vmppNm,
      parseInt(item.balance || 0),
      item.qtval,
      item.price ? (item.price / 100).toFixed(2) : "",
      item.location,
      item.serialNumber,
      item.batchNumber,
      item.expiryDate ? new Date(item.expiryDate).toLocaleDateString("en-GB") : "",
      item.firstScanned ? new Date(item.firstScanned).toLocaleDateString("en-GB") : "",
    ]);
  });

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Popup Export');
  XLSX.writeFile(workbook, `${statusPopupTitle}_Drugs_${new Date().toISOString().slice(0, 10)}.xlsx`);
};


  const resetFilters = () => {
    setViewOption("Summary");
    setSearchQuery("");

setSelectedLocation("");
    setSelectedPharmacy("");
    setSelectedStatus("On shelf");
    setExpiringWithin("");
    setOnShelfMoreThan("");
    setSplitPackOnly("");
    setPriceThreshold(0);
  };


  function getWeeksUntil(dateStr) {
  if (!dateStr) return '';
  const now = new Date();
  const target = new Date(dateStr);
  const diffMs = target - now;
  const diffWeeks = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 7));
  return diffWeeks;
}

function getWeeksSince(dateStr) {
  if (!dateStr) return '';
  const now = new Date();
  const target = new Date(dateStr);
  const diffMs = now - target;
  const diffWeeks = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 7));
  return diffWeeks;
}


const filterData = () => {
  return inventoryData.filter((item) => {
    const now = new Date();

if (expiringWithin) {
  // Parse expiry date
  const expiryDate = item.expiryDate ? new Date(item.expiryDate) : null;

  // Check for 01/01/1980 and exclude
  if (
    expiryDate &&
    expiryDate.getFullYear() === 1980 &&
    expiryDate.getMonth() === 0 && // January is month 0 in JS
    expiryDate.getDate() === 1
  ) {
    return false;
  }

  const expiryThreshold = new Date(now);
  expiryThreshold.setDate(now.getDate() + parseInt(expiringWithin) * 7);
  if (!expiryDate || expiryDate > expiryThreshold) return false;
}

    if (onShelfMoreThan) {
      const scannedDate = item.firstScanned ? new Date(item.firstScanned) : null;
      const shelfThreshold = new Date(now);
      shelfThreshold.setDate(now.getDate() - parseInt(onShelfMoreThan) * 7);
      if (!scannedDate || scannedDate > shelfThreshold) return false;
    }

    if (splitPackOnly && !item.splitpack) {
      return false;
    }

    const matchesSearch = Object.values(item).some(value =>
      value && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesPharmacy = selectedPharmacy ? item.pharmacyName === selectedPharmacy : true;
    const matchesStatus = selectedStatus ? (item.status || '').trim() === selectedStatus : true;
    //const meetsPrice = item.price >= parseInt(priceThreshold || 0);
 const matchesLocation = selectedLocation 
  ? (item.location || '').trim().toLowerCase() === selectedLocation.trim().toLowerCase()
  : true;


    return matchesSearch && matchesPharmacy && matchesStatus && matchesLocation;
  });
};




    const filteredPopupData = statusPopupData ? statusPopupData.filter(item =>
    Object.values(item).some(value =>
      value && value.toString().toLowerCase().includes(popupSearchQuery.toLowerCase())
    )
  ) : [];


  const sortedPopupData = filteredPopupData.sort((a, b) => {
    const key = sortConfig.key;
    if (!key) return 0;
    const aVal = a[key] ?? '';
    const bVal = b[key] ?? '';
    if (aVal < bVal) return sortConfig.direction === 'ascending' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'ascending' ? 1 : -1;
    return 0;
  });



const getSortIndicator = (key) => {
  if (sortConfig.key !== key) return '';
  return sortConfig.direction === 'ascending' ? ' ↑' : ' ↓';
};






  const groupData = (data) => {
    if (viewOption === "Pharmacy") {
      const map = {};
      data.forEach(item => {
        if (!map[item.pharmacyName]) map[item.pharmacyName] = [];
        map[item.pharmacyName].push(item);
      });
      return Object.entries(map).map(([pharmacyName, items]) => ({
        pharmacyName,
        grouped: true,
        totalPackets: items.reduce((sum, i) => sum + parseInt(i.balance || 0), 0),
        totalPrice: items.reduce((sum, i) => sum + i.price, 0),
        items,
        expiresIn: getWeeksUntil(items[0]?.expiryDate),
  onShelfFor: getWeeksSince(items[0]?.firstScanned),
      }));
    }


    
    if (viewOption === "Summary") {
      const map = {};
      data.forEach(item => {
        const key = item.pharmacyName + "|" + (item.drugName || item.vmppNm);
        if (!map[key]) map[key] = [];
        map[key].push(item);
      });
      return Object.entries(map).map(([key, items]) => {
        const [pharmacyName, drug] = key.split("|");
        return {
          pharmacyName,
          drug,
          grouped: items.length > 1,
          totalPackets: items.reduce((sum, i) => sum + parseInt(i.balance || 0), 0),
          totalPrice: items.reduce((sum, i) => sum + i.price, 0),
          items,
          expiresIn: getWeeksUntil(items[0]?.expiryDate),
  onShelfFor: getWeeksSince(items[0]?.firstScanned),
        };
      });
    }




return data.map(item => {
  const expiresIn = getWeeksUntil(item.expiryDate);
  const onShelfFor = getWeeksSince(item.firstScanned);
  return {
    ...item,
    drug: item.drugName || item.vmppNm || "",
    grouped: false,
    totalPackets: parseInt(item.balance || 0),
    totalPrice: item.price,
    expiresIn,
    onShelfFor,
    items: [item],
  };
});

  };

    const openStatusPopup = (status) => {
const data = inventoryData.filter(item => (item.status || '').trim() === status);

    setStatusPopupData(data);
    setStatusPopupTitle(status);
    setPopupSearchQuery("");
  };

  const handleSort = key => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

const displayData = groupData(filterData())
  .filter(group => {
    return group.totalPrice >= parseInt(priceThreshold || 0) * 100;
  })
  .sort((a, b) => {
    const key = sortConfig.key;
    if (!key) return 0;

    const aVal = a[key] ?? '';
    const bVal = b[key] ?? '';

    if (aVal < bVal) return sortConfig.direction === 'ascending' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'ascending' ? 1 : -1;
    return 0;
  });


  const totalPackets = displayData.reduce((sum, i) => sum + (i.totalPackets || 0), 0);
  const totalPrice = displayData.reduce((sum, i) => sum + (i.totalPrice || 0), 0);

  const handleExport = () => {
    const groupName = localStorage.getItem("organisationName") || "Unknown Group";
    const timestamp = new Date().toLocaleString();
    const filters = `Pharmacy: ${selectedPharmacy || 'All'}, Status: ${selectedStatus || 'All'}, Price >= ${priceThreshold}p, Expiring in: ${expiringWithin || 'Any'}, On shelf > ${onShelfMoreThan || 'Any'}, Search: ${searchQuery}`;

    const worksheetData = [
      [groupName],
      [`Generated on: ${timestamp}`],
      [filters],
      [],
      ['Pharmacy', 'Drug', 'No. packets', 'Price (£)', 'Location', 'Serial No', 'Batch No', 'Expiry', 'Status', 'First Scanned']
    ];

    displayData.forEach(item => {
      item.items.forEach(detail => {
        worksheetData.push([
          detail.pharmacyName,
          detail.drugName || detail.vmppNm,
          parseInt(detail.balance || 0),
          detail.price / 100,
          detail.location,

          detail.serialNumber,
          detail.batchNumber,
          detail.expiryDate ? new Date(detail.expiryDate).toLocaleDateString("en-GB") : "",
          detail.status,
          detail.firstScanned ? new Date(detail.firstScanned).toLocaleDateString("en-GB") : ""
        ]);
      });
    });





    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Financials');
    XLSX.writeFile(workbook, `Stock_Financials_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  return (
    <div style={{ paddingBottom: "60px" }}>
      <h1>Stock on shelf - Financials</h1>

      <div style={{
  display: "flex",
  flexWrap: "wrap",
  gap: "6px",
  marginBottom: "10px",
  fontSize: "11px",
  fontWeight: "bold",
  alignItems: "center"
}}>
  <div>
    <label></label>
    <label><input type="radio" checked={viewOption === "Pharmacy"} onChange={() => setViewOption("Pharmacy")} /> Pharm</label>
    <label><input type="radio" checked={viewOption === "Summary"} onChange={() => setViewOption("Summary")} /> Summ</label>
 { 
<label>
  <input type="radio" checked={viewOption === "Detail"} onChange={() => setViewOption("Detail")} /> Det
</label>



}  </div>
<div>
    <label>Pharmacy/location:</label>
    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <select
        style={{ fontSize: "12px", padding: "1px 3px", width: "150px" }}
        value={selectedPharmacy}
        onChange={(e) => setSelectedPharmacy(e.target.value)}
      >
        <option value="">All</option>
        {combinedPharmacyNames.map((name, i) => (
          <option key={i} value={name}>{name}</option>
        ))}
      </select>

      <select
        style={{ fontSize: "12px", padding: "1px 3px", width: "150px" }}
        value={selectedLocation}
        onChange={(e) => setSelectedLocation(e.target.value)}
      >
        <option value="">All</option>
        {uniqueLocations.map((loc, i) => (
          <option key={i} value={loc}>{loc}</option>
        ))}
      </select>
    </div>
</div>
<div>

   <label>
    <input
      type="checkbox"
      checked={splitPackOnly}
      onChange={(e) => setSplitPackOnly(e.target.checked)}
      style={{ marginRight: '4px' }}
    />
    Split pack only
  </label>
</div>

  <div><label>Expires ≤ <input style={{ fontSize: "10px", width: "30px" }} type="number" value={expiringWithin} onChange={(e) => setExpiringWithin(e.target.value)} /></label></div>
  <div><label>On Shelf ≥ <input style={{ fontSize: "10px", width: "30px" }} type="number" value={onShelfMoreThan} onChange={(e) => setOnShelfMoreThan(e.target.value)} /></label></div>
  <div><label>£ ≥ <input style={{ fontSize: "10px", width: "40px" }} type="number" value={priceThreshold} onChange={(e) => setPriceThreshold(e.target.value)} /></label></div>
  <div><label>🔍 <input style={{ fontSize: "10px", width: "80px" }} type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} /></label></div>
{selectedPharmacy && (() => {
  const members = JSON.parse(localStorage.getItem("members") || "[]");
  const matched = members.find(m => m.pharmacyName === selectedPharmacy);
  const pharmacyId = matched ? matched.pharmacyId : "";
  const barcodeValue = `${pharmacyId}%\n${selectedPharmacy}\n${localStorage.getItem("userId") || ""}\n${localStorage.getItem("organisationName") || ""}`;

  return (
    <QRCodeSVG
      value={barcodeValue}
      size={80}
      level="H"
      includeMargin={true}
    />
  );
})()}



<div>
  <button
    style={{
      fontSize: "13px",
      padding: "4px 10px",
      fontWeight: "bold",
      backgroundColor: "#f0f0f0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer"
    }}
    onClick={() => openStatusPopup("On shelf")}
     title="Lists all individual items currently on the shelf in sortable columns. Expiry and status can be edited here."
  >
    On shelf
  </button>
</div>


<div>
  <button
    style={{
      fontSize: "13px",
      padding: "4px 10px",
      fontWeight: "bold",
      backgroundColor: "#f0f0f0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer"
    }}
    onClick={() => openStatusPopup("Archived")}
 title="Lists all items marked as archived."
>
    Archived
  </button>
</div>
<div>
  <button
    style={{
      fontSize: "13px",
      padding: "4px 10px",
      fontWeight: "bold",
      backgroundColor: "#f0f0f0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer"
    }}
    onClick={() => openStatusPopup("Transferred")}
 title="Lists all items that are being transferred."

>
    Transferred
  </button>
</div>
<div>
  <button
    style={{
      fontSize: "13px",
      padding: "4px 10px",
      fontWeight: "bold",
      backgroundColor: "#f0f0f0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer"
    }}
    onClick={() => openStatusPopup("Destroyed")}
 title="Lists all items marked as destroyed."

>
    Destroyed
  </button>
</div>




<div>
  <button
    style={{
      fontSize: "13px",
      padding: "4px 10px",
      fontWeight: "bold",
      backgroundColor: "#f0f0f0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      cursor: "pointer"
    }}
    onClick={resetFilters}
   title="Resets filter conditions to default"

  >
    Reset
  </button>
</div>
<div>
  <button
    style={{
      fontSize: "13px",
      padding: "4px 10px",
      fontWeight: "bold",
      backgroundColor: "#4A90E2",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer"
    }}
    onClick={handleExport}
  >
    Export
  </button>
</div>
</div>

      <table border="1" cellPadding="8" style={{ width: "100%", marginBottom: "60px" }}>
     <thead>
  <tr>
 <th onClick={() => handleSort('pharmacyName')}>
  Pharmacy{getSortIndicator('pharmacyName')}
</th>
<th onClick={() => handleSort('drug')}>
  Drug{getSortIndicator('drug')}
</th>

   
    <th>No. packets</th>
   <th onClick={() => handleSort('totalPrice')}>
  Total value (£){getSortIndicator('totalPrice')}
</th>
   {viewOption === "Detail" && (
  <>
<th>Shelf</th>
    <th>Qty</th>
  
    <th>Serial No.</th>
    <th>Batch No.</th>

    <th onClick={() => handleSort('expiresIn')}>
      Expires in (wks){getSortIndicator('expiresIn')}
    </th>
    <th onClick={() => handleSort('onShelfFor')}>
      On shelf (wks){getSortIndicator('onShelfFor')}
    </th>
  </>
)}

  </tr>
</thead>
<tbody>
  {displayData.map((row, i) => (
  <tr
  key={i}
style={{
  backgroundColor:
    row.expiresIn < -500
      ? "white"
      : row.expiresIn <= 0
      ? "lightcoral"
      : row.grouped
      ? "moccasin"
      : "white",
  cursor: "pointer"
}}

  onClick={() => setPopupData(row.items)}
>

      <td>{row.pharmacyName}</td>

<td>
  {viewOption === "Detail"
    ? row.amppNm || row.vmppNm || ""
    : row.drug || row.amppNm || ""}
</td>







      <td>{row.totalPackets}</td>
      <td>{(row.totalPrice / 100).toFixed(2)}</td>

   <td style={{ maxWidth: "4cm", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
    title={
      viewOption !== "Detail" && row.items
        ? [...new Set(row.items.map(i => i.location || ""))].join(", ")
        : row.location
    }
>
  {viewOption === "Detail"
    ? row.location
    : row.items
      ? [...new Set(row.items.map(i => i.location || ""))].join(", ")
      : row.location}
</td>
     {viewOption === "Detail" && (
  <>
    
<td>
  {row.qtval}
  {row.splitpack === true && (
    <span title="Split pack" style={{ marginLeft: '4px', color: 'orange' }}>
      💊
    </span>
  )}
</td>


      <td>{row.serialNumber}</td>
      <td>{row.batchNumber}</td>

    {(() => {
      const expiresIn = getWeeksUntil(row.items?.[0]?.expiryDate);
      return <td>{expiresIn > -500 ? expiresIn : "n/a"}</td>;
    })()}
    <td>{getWeeksSince(row.items?.[0]?.firstScanned)}</td>
  </>
)}

    </tr>
  ))}
</tbody>
 </table>

      <div style={{ position: "fixed", bottom: 0, width: "100%", backgroundColor: "#f1f1f1", padding: "10px", textAlign: "center" }}>
        Total packets: {totalPackets} &nbsp;&nbsp;&nbsp; Total value: £{(totalPrice / 100).toFixed(2)}
      </div>






{logPopupData && (
  <div
    style={{
      position: 'fixed',
      top: '10%',
      left: '10%',
      width: '80%',
      height: '80%',
      backgroundColor: 'white',
      border: '2px solid black',
      borderRadius: '10px',
      padding: '20px',
      overflowY: 'scroll',
      zIndex: 2000,
    }}
  >
    <h3>Log Details</h3>
    <table border="1" cellPadding="6" style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>Date & Time</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {logPopupData
          .slice() // Create a copy to avoid mutating original
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Descending
          .map((logItem, idx) => (
            <tr key={idx}>
              <td>
                {logItem.createdAt
                  ? new Date(logItem.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "n/a"}
              </td>
              <td>{logItem.action || "n/a"}</td>
            </tr>
          ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", marginTop: "10px" }}>
      <button onClick={() => setLogPopupData(null)}>Close</button>
    </div>
  </div>
)}

{logPopupData && (
  <div
    style={{
      position: 'fixed',
      top: '10%',
      left: '10%',
      width: '80%',
      height: '80%',
      backgroundColor: 'white',
      border: '2px solid black',
      borderRadius: '10px',
      padding: '20px',
      overflowY: 'scroll',
      zIndex: 2000,
    }}
  >
    <h3>Log Details</h3>
    <table border="1" cellPadding="6" style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>Date & Time</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {logPopupData
          .slice() // Create a copy
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Descending
          .map((logItem, idx) => (
            <tr key={idx}>
              <td>
                {logItem.createdAt
                  ? new Date(logItem.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "n/a"}
              </td>
              <td>{logItem.action || "n/a"}</td>
            </tr>
          ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", marginTop: "10px" }}>
      <button onClick={() => setLogPopupData(null)}>Close</button>
    </div>
  </div>
)}



   
{popupData && (
  <div style={{ position: 'fixed', top: '5%', left: '5%', width: '90%', height: '90%', backgroundColor: 'white', border: '2px solid black', borderRadius: '10px', padding: '20px', overflowY: 'scroll', zIndex: 1000 }}>
    <h2>Item Details</h2>
    <table border="1" cellPadding="6" style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>Pharmacy</th><th>Drug</th><th>Packets</th><th>Qty</th><th>Price (£)</th><th>Location</th><th>Serial</th><th>Batch</th><th>Expiry</th><th>Status</th><th>First Scanned</th>
        </tr>
      </thead>
      <tbody>
        {popupData.map((item, i) => {
          let expiryDateValue = "";
          if (item.expiryDate && !item.expiryDate.includes("1980")) {
            expiryDateValue = new Date(item.expiryDate).toISOString().slice(0, 10);
          }

          const canEditExpiry =
            !item.expiryDate ||
            item.expiryDate === "" ||
            item.expiryDate.includes("1980");

          return (
            <tr
              key={i}
              style={{ cursor: item.log && item.log.length > 0 ? "pointer" : "default" }}
              onClick={() => {
                if (item.log && Array.isArray(item.log) && item.log.length > 0) {
                  setLogPopupData(item.log);
                }
              }}
            >
              <td>{item.pharmacyName}</td>
              <td>{item.drugName || item.amppNm}</td>
              <td>{parseInt(item.balance || 0)}</td>
              <td>
                {(!item.splitpack && item.balance !== 0 && item.qtval !== 0)
                  ? item.qtval * item.balance
                  : item.qtval}
                {item.splitpack === true && (
                  <span title="Split pack" style={{ marginLeft: '4px', color: 'orange' }}>
                    💊
                  </span>
                )}
              </td>
              <td>{(item.price / 100).toFixed(2)}</td>
              <td>{item.location}</td>
              <td>{item.serialNumber}</td>
              <td>{item.batchNumber}</td>
            <td onClick={(e) => e.stopPropagation()}>
                <input
                  type="date"
                  value={expiryDateValue}
                  disabled={!canEditExpiry}
                  onChange={async (e) => {
                    const newDate = e.target.value;
                    const oldDate = item.expiryDate && !item.expiryDate.includes("1980")
                      ? new Date(item.expiryDate).toLocaleDateString("en-GB")
                      : "n/a";
                    try {
                    const token = localStorage.getItem("authToken");

await axios.post('https://api.pharmacegroup.co.uk/updateExpiry', {
  id: item._id,
  expiryDate: newDate,
  logEntry: {
    action: `Expiry date changed from ${oldDate} to ${new Date(newDate).toLocaleDateString("en-GB")}`,
    createdAt: new Date().toISOString(),
  }
}, {
  headers: {
    "Authorization": `Bearer ${token}`
  }
});

                      await fetchInventoryData();
                      const updatedData = [...popupData];
                      updatedData[i] = {
                        ...updatedData[i],
                        expiryDate: newDate,
                        updated: new Date().toISOString(),
                        log: [
                          {
                            action: `Expiry date changed from ${oldDate} to ${new Date(newDate).toLocaleDateString("en-GB")}`,
                            createdAt: new Date().toISOString(),
                          },
                          ...(updatedData[i].log || []),
                        ],
                      };
                      setPopupData(updatedData);
                    } catch (error) {
                      console.error("Error updating expiry date:", error);
                      alert("Failed to update expiry date. Please try again.");
                    }
                  }}
                />
              </td>
              <td onClick={(e) => e.stopPropagation()}>
                <select
                  value={item.status}
                  onChange={async (e) => {
                    const newStatus = e.target.value;
                    const oldStatus = item.status || "n/a";
                    try {
                   await axios.post('https://api.pharmacegroup.co.uk/updateStatus', {
  id: item._id,
  status: newStatus,
  logEntry: {
    action: `Status changed from ${oldStatus} to ${newStatus}`,
    createdAt: new Date().toISOString(),
  }
}, {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`
  }
});

                      await fetchInventoryData();
                      const updatedData = [...popupData];
                      updatedData[i] = {
                        ...updatedData[i],
                        status: newStatus,
                        updated: new Date().toISOString(),
                        log: [
                          {
                            action: `Status changed from ${oldStatus} to ${newStatus}`,
                            createdAt: new Date().toISOString(),
                          },
                          ...(updatedData[i].log || []),
                        ],
                      };
                      setPopupData(updatedData);
                    } catch (error) {
                      console.error("Error updating status:", error);
                      alert("Failed to update status. Please try again.");
                    }
                  }}
                >
                  <option value="On shelf">On shelf</option>
                  <option value="Archived">Archived</option>
                  <option value="Destroyed">Destroyed</option>
                  <option value="Transfer to warehouse">Transfer to warehouse</option>
                </select>
              </td>
              <td>{item.firstScanned ? new Date(item.firstScanned).toLocaleDateString("en-GB") : ""}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <div style={{ textAlign: "right", marginTop: "10px" }}>
      <button onClick={() => setPopupData(null)}>Close</button>
    </div>
  </div>
)}


{statusPopupData && (
  <div
    style={{
      position: 'fixed',
      top: '5%',
      left: '5%',
      width: '90%',
      height: '90%',
      backgroundColor: 'white',
      border: '2px solid black',
      borderRadius: '10px',
      padding: '20px',
      overflow: 'hidden',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h2>{statusPopupTitle} Drugs</h2>
      <button onClick={() => setStatusPopupData(null)}>Close</button>
    </div>
    <div style={{ marginBottom: "10px", display: "flex", gap: "10px" }}>
      <input
        type="text"
        placeholder="Search..."
        value={popupSearchQuery}
        onChange={(e) => setPopupSearchQuery(e.target.value)}
        style={{ flex: 1, padding: "5px" }}
      />
      <button onClick={handlePopupExport}>Export</button>
    </div>
    <div style={{ flex: 1, overflowY: "auto" }}>
      <table border="1" cellPadding="6" style={{ width: "100%" }}>
        <thead style={{ position: "sticky", top: 0, background: "#f1f1f1" }}>
          <tr>
            <th onClick={() => handleSort('pharmacyName')}>Pharmacy{getSortIndicator('pharmacyName')}</th>
            <th onClick={() => handleSort('drugName')}>Drug{getSortIndicator('drugName')}</th>
            <th onClick={() => handleSort('balance')}>Packets{getSortIndicator('balance')}</th>
            <th onClick={() => handleSort('qtval')}>Qty{getSortIndicator('qtval')}</th>
            <th onClick={() => handleSort('price')}>Price (£){getSortIndicator('price')}</th>
            <th onClick={() => handleSort('location')}>Location{getSortIndicator('location')}</th>
            <th onClick={() => handleSort('serialNumber')}>Serial{getSortIndicator('serialNumber')}</th>
            <th onClick={() => handleSort('batchNumber')}>Batch{getSortIndicator('batchNumber')}</th>
            <th onClick={() => handleSort('expiryDate')}>Expiry{getSortIndicator('expiryDate')}</th>
            <th onClick={() => handleSort('firstScanned')}>First Scanned{getSortIndicator('firstScanned')}</th>
            <th onClick={() => handleSort('status')}>Status{getSortIndicator('status')}</th>
          </tr>
        </thead>
        <tbody>
          {sortedPopupData.map((item, idx) => {
            let expiryDateValue = "";
            if (item.expiryDate && !item.expiryDate.includes("1980")) {
              expiryDateValue = new Date(item.expiryDate).toISOString().slice(0, 10);
            }
            const canEditExpiry =
              !item.expiryDate ||
              item.expiryDate === "" ||
              item.expiryDate.includes("1980");

            return (
              <tr
                key={idx}
                style={{ cursor: item.log && item.log.length > 0 ? "pointer" : "default" }}
                onClick={() => {
                  if (item.log && Array.isArray(item.log) && item.log.length > 0) {
                    setLogPopupData(item.log);
                  }
                }}
              >
                <td>{item.pharmacyName}</td>
                <td>{item.drugName || item.vmppNm}</td>
                <td>{parseInt(item.balance || 0)}</td>
                <td>{item.qtval}</td>
                <td>{item.price ? (item.price / 100).toFixed(2) : ""}</td>
                <td>{item.location}</td>
                <td>{item.serialNumber}</td>
                <td>{item.batchNumber}</td>
                <td onClick={(e) => e.stopPropagation()}>
                  <input
                    type="date"
                    value={expiryDateValue}
                    disabled={!canEditExpiry}
                    onChange={async (e) => {
                      const newDate = e.target.value;
                      const oldDate = item.expiryDate && !item.expiryDate.includes("1980")
                        ? new Date(item.expiryDate).toLocaleDateString("en-GB")
                        : "n/a";
                     try {
  await axios.post('https://api.pharmacegroup.co.uk/updateExpiry', {
    id: item._id,
    expiryDate: newDate,
    logEntry: {
      action: `Expiry date changed from ${oldDate} to ${new Date(newDate).toLocaleDateString("en-GB")}`,
      createdAt: new Date().toISOString(),
    }
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`
    }
  });

                        await fetchInventoryData();
                      } catch (error) {
                        console.error("Error updating expiry date:", error);
                        alert("Failed to update expiry date. Please try again.");
                      }
                    }}
                  />
                </td>
                <td>{item.firstScanned ? new Date(item.firstScanned).toLocaleDateString("en-GB") : ""}</td>
                <td onClick={(e) => e.stopPropagation()}>
                  <select
                    value={item.status}
                    onChange={async (e) => {
                      const newStatus = e.target.value;
                      const oldStatus = item.status || "n/a";
                  try {
  await axios.post('https://api.pharmacegroup.co.uk/updateStatus', {
    id: item._id,
    status: newStatus,
    logEntry: {
      action: `Status changed from ${oldStatus} to ${newStatus}`,
      createdAt: new Date().toISOString(),
    }
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`
    }
  });

                        await fetchInventoryData();
                      } catch (error) {
                        console.error("Error updating status:", error);
                        alert("Failed to update status. Please try again.");
                      }
                    }}
                  >
                    <option value="On shelf">On shelf</option>
                    <option value="Archived">Archived</option>
                    <option value="Destroyed">Destroyed</option>
                    <option value="Transfer to warehouse">Transfer to warehouse</option>
                  </select>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
)}


</div>
  );




  

};




export default StockFinancials;
